const getShortList = ( [ first, ...rest ] ) => `${first}${rest.length ? ` +${rest.length}` : ''}`

export default getShortList
